import SubHeaders from '@/components/Headers/SubHeaders'
import { useTranslation } from 'react-i18next'
import { paths } from '@/utils/path'
import { TemplatePreview } from '../../templates'

const Templates: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.ticket, title: t('ticket-list') },
                    { path: '', title: 'Templates' },
                ]}
            />
            <TemplatePreview />
        </div>
    )
}

export default Templates
